import { render, staticRenderFns } from "./PageVenueBotton.vue?vue&type=template&id=4c166266"
import script from "./PageVenueBotton.vue?vue&type=script&lang=js"
export * from "./PageVenueBotton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports